import { render, staticRenderFns } from "./relatorio-risco.vue?vue&type=template&id=c130da5a&scoped=true"
import script from "./relatorio-risco.vue?vue&type=script&lang=js"
export * from "./relatorio-risco.vue?vue&type=script&lang=js"
import style0 from "./relatorio-risco.vue?vue&type=style&index=0&id=c130da5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c130da5a",
  null
  
)

export default component.exports